import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface CommonState {
  isTermsAccepted: boolean;
  submitSuccess: boolean;
  checkoutErrorMessage: string | null;
  purchaseCompleted: boolean;
  mandatoryComponents: string[];
  fontFamily: string;
}

const initialState: CommonState = {
  isTermsAccepted: false,
  submitSuccess: false,
  checkoutErrorMessage: null,
  purchaseCompleted: false,
  mandatoryComponents: [],
  fontFamily: 'Arial',
};

const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setIsTermsAccepted(state, action: PayloadAction<boolean>) {
      state.isTermsAccepted = action.payload;
    },
    setSubmitSuccess(state, action: PayloadAction<boolean>) {
      state.submitSuccess = action.payload;
    },
    setCheckoutErrorMessage(state, action: PayloadAction<string | null>) {
      state.checkoutErrorMessage = action.payload;
    },
    setPurchaseCompleted(state, action: PayloadAction<boolean>) {
      state.purchaseCompleted = action.payload;
    },
    setMandatoryComponents(state, action: PayloadAction<string[]>) {
      state.mandatoryComponents = action.payload;
    },
    setFontFamily(state, action: PayloadAction<string>) {
      state.fontFamily = action.payload;
    },
  },
});

export const {
  setIsTermsAccepted,
  setSubmitSuccess,
  setCheckoutErrorMessage,
  setPurchaseCompleted,
  setMandatoryComponents,
  setFontFamily,
} = commonSlice.actions;

export default commonSlice.reducer;
